module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"inbox":"Inbox","albums":"Albums","favorites":"Favorites","recents":"Recents"},"fr":{"inbox":"Boîte de réception","albums":"Albums","favorites":"Favoris","recents":"Récents"}}')
  delete Component.options._Ctor
}
